<template>
  <transition name="fade">
    <ul v-if="true">
      <!-- <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral url="/" label="使い方（はじめに）">
        <template v-slot:icon>
          <IconBase :width="24" :height="24" view-box="0 0 24 24" :icon-color="iconColor">
            <IconWakaba />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li> -->

      <li class="p-the-header-navi-on-general__navi__item">
        <NaviItemLinkForSpOnGeneral
          :url="urlFAQ"
          label="FAQ"
          icon-color="transparent"
        >
          <template v-slot:icon>
            <IconBase
              :width="20"
              :height="20"
              view-box="0 0 23 27"
              :icon-color="iconColor"
            >
              <IconFaqBalloon />
            </IconBase>
          </template>
        </NaviItemLinkForSpOnGeneral>
      </li>
      <li class="p-the-header-navi-on-general__navi__item">
        <NaviItemLinkForSpOnGeneral
          :url="urlNotification"
          label="お問い合わせ"
          icon-color="transparent"
        >
          <template v-slot:icon>
            <IconBase
              :width="20"
              :height="20"
              view-box="0 0 24 24"
              icon-color="transparent"
            >
              <IconMail />
            </IconBase>
          </template>
        </NaviItemLinkForSpOnGeneral>
      </li>
    </ul>
  </transition>
</template>

<script lang="ts">
import NaviItemLinkForSpOnGeneral from "@/common/components/organisms/header/general/NaviItemLinkForSpOnGeneral.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconWakaba from "@/common/components/icons/IconWakaba.vue";
import IconFaqBalloon from "@/common/components/icons/IconFaqBalloon.vue";
import IconMail from "@/common/components/icons/IconMail.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  name: "TheHeaderNaviOfOtherMenu",
  props: {
	iconColor: { type: String, required: true }
  },
  components: {
    NaviItemLinkForSpOnGeneral,
    IconBase,
    IconWakaba,
    IconFaqBalloon,
    IconMail
  }
})
export default class TheHeaderNaviOfOtherMenu extends Vue {
  iconColor!: string;

  get urlNotification() {
    return process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/memberfaqic/index.html";
  }

  get urlFAQ() {
    return process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/incentive/faq3/";
  }
}
</script>
